import {
  CollectionEntryOptions,
  createCollectionEntryExtension,
} from '@spotify/plugin-confidence-collections-react';

import { surfacesPlugin } from '../plugin';
import { surfaceRouteRef } from '../routes';

export const SurfaceCollectionEntryExtension = surfacesPlugin.provide(
  createCollectionEntryExtension({
    id: 'surface',
    resourceType: 'Surface',
    routeRef: surfaceRouteRef,
    predicate: ({ resource }: CollectionEntryOptions) =>
      '__typename' in resource && resource.__typename === 'WorkflowV1Surface',
    render: () => null,
  }),
);
